import { StyledLoadingIcon } from './styles'

export const Spinner = () => <StyledLoadingIcon size="button" />
